import React from 'react';
import './Gewichtsberechnung.css';
import { calculateBlechdicke, calculateFlaecheLueftungskanal, calculateLaengsteSeite, calculateLueftungsgehaeusegewicht } from '../calculations/weight';

class Lueftungsgehaeusegewichtberechnung extends React.Component {
  constructor(props) {
      super(props);
      //this.handleChange = this.handleChange.bind(this);
      this.state = {
          value: null,
      };
  }

  _Lueftungsgehaeusegewicht(){
        var masseKanal = calculateLueftungsgehaeusegewicht(this.props);
        this.props.handleLuftungsgehausegewichtChange(masseKanal);
        return masseKanal;
  }

  _Flaeche_Luefungskanal(){
      return calculateFlaecheLueftungskanal(this.props);

  }
  _Blechdicke(){
      return calculateBlechdicke(this.props);
  }
  _LaengsteSeite(){
       return calculateLaengsteSeite([this.props.Lueftungskanalbreite,this.props.Lueftungskanalhoehe,this.props.Lueftungskanellaenge]);
  }


  render() {
    this._Lueftungsgehaeusegewicht();
      return null;//this._Lueftungsgehaeusegewicht();//his._Lueftungsgehaeusegewicht().toFixed(2);//this._Blechdicke();//this._Flaeche_Luefungskanal();
  }
}
export default Lueftungsgehaeusegewichtberechnung;
